// extracted by mini-css-extract-plugin
module.exports = {"banner":"_1K7bm"};